module.exports = __webpack_public_path__ + "img/historialPti.b785aace.svg";